import React from "react";
import "../styles/Section2.css";
import "../Fonts/Jomolhari/Jomolhari-Regular.ttf"

function Section2(){
    return(<>


<div className="container sect3bcolor">


        <div className=" col-lg-12 py-5 px-4">
          <div className="row">
            <div className="d-flex flex-column align-items-lg-start align-items-center col-lg-6">
              <div className="sect2bannerheading font-face-jl text-lg-start text-center">
              MODERN SPACES AND PREMINUM VILLAS DEVELOPMENT AND SALES AGENCY
              </div>

              <div className="sect2bannersubheading pt-3 text-lg-start text-center">
              Your Investment, Your Future – Secure It Today!
              </div>
            </div>

            <div className="sect3aboutusimg col-lg-6 pt-lg-0 pt-4">
              <img
                src={require("../images/investm1.jpg")}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>



        <div className="mt-4 col-lg-12 py-5 px-4">
          <div className="row">


          <div className="sect3aboutusimg col-lg-6 pt-lg-0 pt-4">
              <img
                src={require("../images/brock.jpg")}
                alt=""
                className="img-fluid"
              />
            </div>

            

          <div className="ps-md-5 d-flex flex-column align-items-lg-start align-items-center col-lg-6">
              <div className="sect2bannerheading font-face-jl text-lg-start text-center">
              From Savings to Success – Make Your Money Fly!
              </div>

              <div className="sect2bannersubheading pt-3 text-lg-start text-center">
              We are a leading global investment firm, investing on behalf of institutions and individuals around the world. Our success is based on our proven investment and operational expertise—and at the heart of it all is the KPN Ecosystem. 
              </div>
            </div>

            
          </div>
        </div>

        



      </div>

    </>
)
}

export default Section2;